var map = {
	"./10/ComplianceScoreCardView/index.js": [
		92506,
		6655,
		2506
	],
	"./10/ComplianceScoreCardViewCRB/index.js": [
		13035,
		6655,
		3035
	],
	"./10/ComplianceScoreCardViewSap/index.js": [
		75962,
		6655,
		5962
	],
	"./10/DmsTableForDcr/index.js": [
		6776,
		6776
	],
	"./10/ListCurrentTeamDetails/index.js": [
		32504,
		2504
	],
	"./10/PdfSignaturePlacer/index.js": [
		7985,
		7985
	],
	"./10/VendorStatutoryTemplateDownloadView/index.js": [
		80869,
		869
	],
	"./11/ComparisonView/index.js": [
		70651,
		651
	],
	"./12/GraphChat/index.js": [
		23094,
		3094
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 66365;
module.exports = webpackAsyncContext;